export default __webpack_public_path__ + "static/media/pictogramCamera64.19aa04f2.svg";